import { Paper } from '@mui/material'
import type { FC } from 'react'
import { useEffect, useState } from 'react'

import { getNavigationDrawerWidth } from '@/components/MenuBar'
import { headerAppBarHeight } from '@/components/UI/HeaderAppBar'

interface Props {
  isNavigationDrawerOpen: boolean
  yOffset: number
}

const PageContentStickyBar: FC<Props> = ({
  children,
  isNavigationDrawerOpen,
  yOffset,
}) => {
  const [shouldDisplayStickyHeader, setShouldDisplayStickyHeader] =
    useState<boolean>(false)

  useEffect(() => {
    const onScroll = () => {
      setShouldDisplayStickyHeader(window.pageYOffset > yOffset)
    }

    window.addEventListener('scroll', onScroll)

    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  }, [yOffset])

  return !shouldDisplayStickyHeader ? (
    <></>
  ) : (
    <Paper
      elevation={10}
      sx={{
        position: 'fixed',
        width: `calc(100% - ${getNavigationDrawerWidth(isNavigationDrawerOpen)})`,
        zIndex: 1,
        top: headerAppBarHeight,
      }}
    >
      {children}
    </Paper>
  )
}

export default PageContentStickyBar
